<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Formulario de creación de usuarios
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver a Gestión de Usuarios" v-if="!procesando" @click="gestionUsuarios()" >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">

            <form enctype="multipart/form-data" v-on:submit.prevent="crearUsuario" v-if="procesando == false && error == false">

              <h2>Datos de identificación</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_nombre">Primer nombre</label>
                    <b-form-input type="text" :state="validarPrimerNombre()" v-model="usuario.primer_nombre" name="primer_nombre" :disabled="procesando" placeholder="Ingrese primer nombre"></b-form-input>
                    <b-form-valid-feedback>
                      Primer nombre válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese primer nombre válido. Ej: Pedro
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="segundo_nombre">Segundo nombre</label>
                    <b-form-input type="text" :state="validarSegundoNombre()" v-model="usuario.segundo_nombre" name="segundo_nombre" :disabled="procesando" placeholder="Ingrese segundo nombre"></b-form-input>
                    <b-form-valid-feedback>
                      Segundo nombre válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese segundo nombre válido. Ej: Pablo
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_apellido">Primer apellido</label>
                    <b-form-input type="text" :state="validarPrimerApellido()" v-model="usuario.primer_apellido" name="primer_apellido" :disabled="procesando" placeholder="Ingrese primer apellido"></b-form-input>
                    <b-form-valid-feedback>
                      Primer apellido válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese primer apellido válido. Ej: Vargas
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="segundo_apellido">Segundo apellido</label>
                    <b-form-input type="text" :state="validarSegundoApellido()" v-model="usuario.segundo_apellido" name="segundo_apellido" :disabled="procesando" placeholder="Ingrese segundo apellido"></b-form-input>
                    <b-form-valid-feedback>
                      Segundo apellido válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese segundo apellido válido. Ej: Carvajal
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="genero">Genero</label>
                    <b-form-select class="form-control" :state="validarGenero()" name="genero" :disabled="procesando" v-model="usuario.genero">
                      <option disabled value="">Seleccione genero</option>
                      <option v-for="genero in generos" v-bind:value="genero.codigo">
                        {{ genero.nombre }}
                      </option>
                    </b-form-select>
                    <b-form-valid-feedback>
                      Género válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Seleccione un género válido.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group>
                    <label for="fecha_nacimiento">Fecha de nacimiento</label>
                    <br />
                    <datepicker v-model="fecha_nacimiento" :value="obtenerFechaNacimientoRestriccion()" type="date" :editable="false" :lang="'es'" @change="obtenerFechaNacimiento()" :format="'DD/MM/YYYY'" :clearable="false" :not-after="obtenerFechaNacimientoRestriccion()"></datepicker>
                    <b-form-input type="text" :state="validarFechaNacimiento()" v-model="usuario.fecha_nacimiento" name="fecha_nacimiento" v-show="false" :disabled="procesando" placeholder="Ingrese fecha de nacimiento"></b-form-input>
                    <b-form-valid-feedback>
                      Fecha de nacimiento válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Debe seleccionar una fecha de nacimiento válida.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-card class="bg-info text-center">
                    Recuerde que Ud debe tener una edad mínima de 10 años.
                  </b-card>
                </b-col>
              </b-row>

              <h2>Datos de acceso </h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="correo_electronico">Correo electrónico</label>
                    <b-form-input type="email" :state="validarCorreoElectronico()" v-model="usuario.correo_electronico" name="correo_electronico" :disabled="procesando" placeholder="Ingrese correo electrónico"></b-form-input>
                    <b-form-valid-feedback>
                      Correo electrónico válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese un correo electrónico válido. Ej: correo@dominio.com
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="confirmacion_correo_electronico">Confirmación correo electrónico</label>
                    <b-form-input type="email" :state="validarConfirmacionCorreoElectronico()" v-model="usuario.confirmacion_correo_electronico" name="confirmacion_correo_electronico" :disabled="procesando" placeholder="Ingrese confirmación correo electrónico"></b-form-input>
                    <b-form-valid-feedback>
                      Confirmación correo electrónico válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese confirmación correo electrónico.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Personalización avatar</h2>
              <hr />

              <br />
              <br />

              <b-row>
                <b-col sm="6" class="text-center">
                  <img :src="'static/img/avatars/' + usuario.ruta_imagen_usuario" v-if="!Boolean(imagen_avatar)" style="width: 200px; height: 200px;" class="img-avatar" alt="Avatar seleccionado">
                  <img :src="imagen_avatar" v-if="Boolean(imagen_avatar)" style="width: 200px; height: 200px;" class="img-avatar" alt="Avatar seleccionado">
                </b-col>
                <b-col sm="6">
                  <b-list-group>
                    <b-list-group-item v-for="(avatar, index) in avatares" :key="avatar.ruta_imagen_usuario" :active="avatar.active" :disabled="avatar.disabled" @click="seleccionarOpcionAvatar(index)" style="cursor: pointer;" class="d-flex justify-content-between align-items-center">

                      <span v-if="avatar.item < 3 || avatar.item === 3 && avatar.active === false">{{avatar.opcion}}</span>

                      <div v-if="avatar.item > 2 && avatar.active === true">
                        <label variant="outline-info text-white">Seleccione una imagen</label>

                        <picture-input
                          ref="file_avatar"
                          @change="onChangedImage"
                          @remove="onRemovedImage"
                          accept="image/jpeg, image/png, image/gif"
                          buttonClass="btn btn-outline-info text-white"
                          removeButtonClass="btn btn-danger"
                          :removable="true"
                          :customStrings="{
                            upload: '<h1>Upload it!</h1>',
                            drag: 'Arrastre y suelte su imagen aquí',
                            change: 'Cambiar',
                            remove: 'Quitar'
                          }"
                        >
                        </picture-input>
                      </div>

                      <img :src="'static/img/avatars/' + avatar.ruta_imagen_usuario" v-if="avatar.item < 3 || avatar.item === 3 && !Boolean(imagen_avatar)" style="width: 30px; height: 30px;" class="img-avatar" :alt="avatar.opcion">
                      <img :src="imagen_avatar" v-if="avatar.item === 3 && avatar.active === true && Boolean(imagen_avatar)" style="width: 30px; height: 30px;" class="img-avatar" :alt="avatar.opcion">

                    </b-list-group-item>
                  </b-list-group>

                </b-col>
              </b-row>

              <br />
              <br />

              <h2>Guardar nueva cuenta de usuario</h2>
              <hr />
              <pre>{{usuario}}</pre>

              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="abreviatura">Activo</label>
                    <br>
                    <c-switch type="text" size="lg" variant="success" on="Si" off="No" v-model="usuario.activo" name="activo" :disabled="procesando" :checked="usuario.activo"/>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <b-button type="button" variant="secondary" style="cursor: not-allowed;" disabled v-if="!validarFormulario ()" v-b-tooltip.hover title="Crear cuenta de usuario"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                    <b-button type="submit" variant="primary" v-if="validarFormulario ()" v-b-tooltip.hover title="Crear cuenta de usuario"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                  </b-form-group>
                </b-col>
              </b-row>

            </form>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert show class="text-center" variant="danger" v-else-if="procesando == false && error == true">
              {{mensaje_error}}
            </b-alert>

          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->

  </div>
</template>

<script>
// import Vue from 'vue'

import router from '@/router/index.js'
import usuario from '@/js/usuario.js'
import genero from '@/js/genero.js'
import cSwitch from '@/components/Switch'
import Datepicker from 'vue2-datepicker'
import moment from 'moment'

import validationField from 'validationField'
import PictureInput from 'vue-picture-input'

export default {
  name: 'registro-usuario',
  components: {
    cSwitch,
    'datepicker': Datepicker,
    moment,
    PictureInput
  },
  mounted () {
    this.procesando = false
    this.error = false

    this.listarGeneros()
  },
  data () {
    return {
      procesando: true,
      error: false,
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      // ruta_back: Vue.http.options.root,
      generos: [],
      avatares: [
        {
          item: 0,
          opcion: 'Anónimo',
          ruta_imagen_usuario: 'registered.jpeg',
          active: true,
          disabled: false
        },
        // {
        //   item: 1,
        //   opcion: 'Masculino',
        //   ruta_imagen_usuario: 'masculino.png',
        //   active: false,
        //   disabled: false
        // },
        // {
        //   item: 2,
        //   opcion: 'Femenino',
        //   ruta_imagen_usuario: 'femenino.png',
        //   active: false,
        //   disabled: false
        // },
        {
          item: 3,
          opcion: 'Personalizado',
          ruta_imagen_usuario: 'personalizado.jpeg',
          active: false,
          disabled: false
        }
      ],
      fecha_nacimiento: this.obtenerFechaNacimientoRestriccion(),
      imagen_avatar: null,
      file_imagen_avatar: null,
      usuario: {
        primer_nombre: 'Prueba',
        segundo_nombre: '',
        primer_apellido: 'Cuatro',
        segundo_apellido: '',
        genero: '8c4f0cf0-9c8f-11e8-b908-69b6ea1a6b8e',
        fecha_nacimiento: this.obtenerFechaNacimientoPermitida(),
        correo_electronico: 'prueba4@yopmail.com',
        confirmacion_correo_electronico: 'prueba4@yopmail.com',
        imagen_usuario_personalizada: false,
        ruta_imagen_usuario: 'registered.jpeg',
        activo: false,
        acepta_terminos: false
      }
    }
  },
  computed: {
    activo: {
      get () {
        return this.usuario.activo === true
      },
      set (newValue) {
        this.usuario.activo = newValue
      }
    }
  },
  methods: {
    listarGeneros () {
      this.procesando = true
      this.error = false

      genero.getListadoGeneros().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.generos = response.data
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    createInput (file) {
      var reader = new FileReader()
      reader.onload = (e) => {
        this.imagen_avatar = reader.result
      }

      reader.readAsDataURL(file)
    },
    onChangedImage () {
      if (this.$refs.file_avatar[0].file) {
        this.createInput(this.$refs.file_avatar[0].file)
      }
    },
    onRemovedImage () {
      this.usuario.ruta_imagen_usuario = 'personalizado.jpeg'
      this.imagen_avatar = null
    },
    validarFormulario () {
      let valido = true

      if (
        !this.validarPrimerNombre() ||
        !this.validarSegundoNombre() ||
        !this.validarPrimerApellido() ||
        !this.validarSegundoApellido() ||
        !this.validarGenero() ||
        !this.validarFechaNacimiento() ||
        !this.validarCorreoElectronico() ||
        !this.validarConfirmacionCorreoElectronico()
      ) {
        valido = false
      }
      return valido
    },
    validarPrimerNombre () {
      let valido = true

      if (!this.usuario.primer_nombre || !validationField('short-string', this.usuario.primer_nombre)) {
        valido = false
      }
      return valido
    },
    validarSegundoNombre () {
      let valido = true

      if (this.usuario.segundo_nombre && !validationField('short-string', this.usuario.segundo_nombre)) {
        valido = false
      }
      return valido
    },
    validarPrimerApellido () {
      let valido = true

      if (!this.usuario.primer_apellido || !validationField('short-string', this.usuario.primer_apellido)) {
        valido = false
      }
      return valido
    },
    validarSegundoApellido () {
      let valido = true

      if (this.usuario.segundo_apellido && !validationField('short-string', this.usuario.segundo_apellido)) {
        valido = false
      }
      return valido
    },
    validarGenero () {
      let valido = true

      if (!this.usuario.genero) {
        valido = false
      }
      return valido
    },
    obtenerFechaNacimiento () {
      this.usuario.fecha_nacimiento = moment(this.fecha_nacimiento).format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoPermitida () {
      return moment().add(-10, 'year').add(-1, 'day').format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoRestriccion () {
      return moment().add(-10, 'year').add(0, 'day').format('YYYY-MM-DD')
    },
    validarFechaNacimiento () {
      let valido = true

      if (!this.usuario.fecha_nacimiento || this.usuario.fecha_nacimiento >= this.obtenerFechaNacimientoRestriccion()) {
        valido = false
      }
      return valido
    },
    validarCorreoElectronico () {
      let valido = true

      if (!this.usuario.correo_electronico || !validationField('email', this.usuario.correo_electronico)) {
        valido = false
      }
      return valido
    },
    validarConfirmacionCorreoElectronico () {
      let valido = true

      if (!this.usuario.confirmacion_correo_electronico || this.usuario.correo_electronico !== this.usuario.confirmacion_correo_electronico) {
        valido = false
      }
      return valido
    },
    seleccionarOpcionAvatar (opcion) {
      if (opcion < 1 || (opcion === 1 && this.avatares[opcion].active === false)) {
        this.imagen_avatar = null
      }

      this.avatares.forEach(function (avatar, value) {
        avatar.active = false
      })

      if (this.avatares[opcion].item < 3) {
        this.avatares[opcion].imagen_usuario_personalizada = false
        this.usuario.imagen_usuario_personalizada = false
      } else {
        this.avatares[opcion].imagen_usuario_personalizada = true
        this.usuario.imagen_usuario_personalizada = true
      }
      this.usuario.ruta_imagen_usuario = this.avatares[opcion].ruta_imagen_usuario

      this.avatares[opcion].active = true
    },
    crearUsuario () {
      this.procesando = true
      this.error = false

      if (this.usuario.imagen_usuario_personalizada === true) {
        usuario.contentType = 'multipart/form-data'

        const imagen = this.$refs.file_avatar[0].file
        usuario.usuario = new FormData()
        usuario.usuario.append('primer_nombre', this.usuario.primer_nombre)
        usuario.usuario.append('segundo_nombre', this.usuario.segundo_nombre)
        usuario.usuario.append('primer_apellido', this.usuario.primer_apellido)
        usuario.usuario.append('segundo_apellido', this.usuario.segundo_apellido)
        usuario.usuario.append('genero', this.usuario.genero)
        usuario.usuario.append('fecha_nacimiento', this.usuario.fecha_nacimiento)
        usuario.usuario.append('correo_electronico', this.usuario.correo_electronico)
        usuario.usuario.append('confirmacion_correo_electronico', this.usuario.confirmacion_correo_electronico)
        usuario.usuario.append('imagen_usuario_personalizada', this.usuario.imagen_usuario_personalizada)
        usuario.usuario.append('ruta_imagen_usuario', imagen)
        usuario.usuario.append('activo', this.usuario.activo)
        usuario.usuario.append('acepta_terminos', this.usuario.acepta_terminos)
      } else {
        usuario.contentType = 'application/json'
        usuario.usuario = this.usuario
      }

      usuario.postUsuario().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.gestionUsuarios()
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    gestionUsuarios () {
      router.push({
        name: 'gestion-usuarios-listado-usuarios'
      })
    }
  }
}
</script>

<style lang="scss">
.file-avatar {
  width: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Usuario/Crear.vue